import React, {useContext, useEffect, useState} from "react";
import {GlobalContext} from "../../../../util/state/GlobalContextProvider";
import {useRecoilState} from "recoil";
import {unitsAtom, unitsEnumAtom} from "../../state/rentalPeriodsRecoil";
import {ancillaryTypeAtom, chargingWayAtom, currencyAtom,} from "../../state/constantsRecoil";
import {fromGenericBeToGenericFe} from "../../utils";
import {
    buildAncillaryForm,
    buildEntityRequestFromFormValues,
    getAncillaryBaseDefinitionValidationSchema,
    initialAncillaryForm,
} from "./BaseDefinition/AncillaryBaseDefinitionForm";
import {useLocation, useParams} from "react-router-dom";
import AncillaryBaseDefinition from "./BaseDefinition/AncillaryBaseDefinition";
import AncillaryMatrix from "../Ancillary/Matrix/AncillaryMatrix";
import DialogComponent from "../../common/components/DialogComponent";
import {setSnackbar} from "../../../../util/state/globalAction";
import {snackbarTypes} from "../../../../util/state/globalVariables";
import {useAncillaryRepository} from "../../api/repositories/AncillaryRepository";
import {useConstantsRepository} from "../../api/repositories/ConstantsRepository";
import {useTpUnitRepository} from "../../api/repositories/TpUnitRepository";
import Loading from "../../common/components/Loading";
import {Box, Grid, Tab, Tabs} from "@mui/material";
import {useTranslation} from "react-i18next";
import {
    DialogInterface,
    SelectElementModelBE,
    SelectElementModelFE,
    UseLocationStateModel
} from "../../api/types/generic";
import {
    AncillaryEntityRequest,
    AncillaryEntityResponse,
    FormAncillaryModel,
    RouteParams
} from "../../api/types/ancillary";
import {yupResolver} from "@hookform/resolvers/yup/dist/yup";
import {FormProvider, useForm} from "react-hook-form";
import {useCommercialSegmentRepository} from "../../api/repositories/CommercialSegmentRepository";
import {commercialSegmentListAtom} from "../../state/commercialSegmentsAtom";
import OWRouteMatrix from "../OWAncillary/Matrix/OWRouteMatrix";
import {useProviderRepository} from "../../api/repositories/ProviderRepository";
import {ancillaryAtom, ancillaryServiceItem, exceptionPackAtom} from "../../state/ancillariesRecoil";
import {useRentalPeriodRepository} from "../../api/repositories/RentalPeriodRepository";
import {ExceptionListEntityResponse} from "../../api/types/exceptionList";


type TabPanelProps = {
    children?: React.ReactNode;
    index: number;
    value: number;
};

function TabPanel(props: TabPanelProps) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{p: 3}}>{children}</Box>}
        </div>
    );
}

const AncillaryContent = ({
                              readOnly,
                              ancillaryId,
                          }: {
    readOnly: boolean;
    ancillaryId?: number;
}) => {
    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    // Use Context
    const {dispatchGlobalData} = useContext(GlobalContext);

    const {id} = useParams<RouteParams>();

    // Use Location
    const location = useLocation();
    const locationState: UseLocationStateModel = location.state as UseLocationStateModel;

    // Use Context
    const {
        globalData: {user},
    } = useContext(GlobalContext);

    //setto tutte le legalEntities options e le passo al filtro di ricerca ["all", "drivalia_it","drivalia_fr"]
    const legalEntityOptions: SelectElementModelFE[] = user.legalEntities?.map(
        (el: SelectElementModelBE) => ({
            code: el.name,
            label: t('translation:legalEntities.'.concat(el.name))
        })
    );

    //se utente clicca su all, mando  ["drivalia_it","drivalia_fr"]
    const optionsFiltered = legalEntityOptions
        .filter(function (el) {
            return el.code !== "all";
        });

    const everyLegalEntitiesWithoutAll = legalEntityOptions
        .map((el) => el.code as string)
        .filter((el) => el !== "all");

    //setto tutti i dealers options
    const dealerOption: SelectElementModelFE[] = user.dealers?.map(
        (el: SelectElementModelBE) => ({
            code: el.name,
            label: t('translation:dealers.'.concat(el.name))
        })
    );

    const dealerFilteredOptions = dealerOption
        .map((el) => el.code as string)
        .filter((el) => el !== "all");

    // Use Recoil
    const [, setCommercialSegmentList] = useRecoilState(commercialSegmentListAtom);
    const [, setUnits] = useRecoilState(unitsAtom);
    const [, setUnitsEnum] = useRecoilState<string[]>(unitsEnumAtom);
    const [, setCurrencies] = useRecoilState(currencyAtom);
    const [, setChargingWays] = useRecoilState(chargingWayAtom);
    const [, setAncillaryTypes] = useRecoilState(ancillaryTypeAtom);
    const [ancillary, setAncillary] = useRecoilState<AncillaryEntityResponse | null>(ancillaryAtom);
    const [exceptionPack] = useRecoilState<ExceptionListEntityResponse | null>(exceptionPackAtom)

    // Use State
    const [providers, setProviders] = useState<SelectElementModelFE[]>([]);
    const [ancillaryForm, setAncillaryForm] = useState<FormAncillaryModel | null>(
        null
    );
    const [originalAncillaryForm, setOriginalAncillaryForm] =
        useState<FormAncillaryModel | null>(null);
    const [value, setValue] = useState<number>(0);
    const [dialog, setDialog] = useState<DialogInterface | null>(null);
    const [ancillaryInUse, setAncillaryInUse] = useState<boolean>(false);
    const [serviceItem, setServiceItem] = useRecoilState<any>(ancillaryServiceItem)

    // Use Repository Hooks
    const {getAncillary, getAncillaryInUse, getServiceItem} = useAncillaryRepository();
    const {getCurrencies, getChargingWays, getTypes} = useConstantsRepository();
    const {getTpUnits} = useTpUnitRepository();
    const {getTpUnitsEnumNoAbsolute} = useRentalPeriodRepository();
    const {getCommercialSegments} = useCommercialSegmentRepository();
    const {getProviders} = useProviderRepository();

    const handleSubmit = (values: FormAncillaryModel) => {
        setValue(1);
        const ancillaryEntityRequest: AncillaryEntityRequest = buildEntityRequestFromFormValues(values, everyLegalEntitiesWithoutAll, dealerFilteredOptions);
        // UPDATE ANCILLARY BASE
        if (originalAncillaryForm && ancillaryForm?.id) {
            const updateAncillary: AncillaryEntityResponse = {id: ancillaryForm?.id, ...ancillaryEntityRequest};
            setAncillary(updateAncillary);
        }
    };

    // Use Form
    const form = useForm<FormAncillaryModel>({
        defaultValues: ancillaryForm || initialAncillaryForm(legalEntityOptions, dealerOption),
        resolver: yupResolver(
            getAncillaryBaseDefinitionValidationSchema(t, ancillary),
            {},
            {
                rawValues: true,
            }
        ),
        shouldUnregister: false,
    });

    const getStaticContents = async () => {
        try {
            const tpUnitsData = await getTpUnitsEnumNoAbsolute();
            const currenciesData = await getCurrencies();
            const chargingWaysData = await getChargingWays();
            const typesData = await getTypes();

            const commercialSegmentsData = await getCommercialSegments();

            setUnitsEnum(tpUnitsData);

            const commercialSegmentList: SelectElementModelFE[] =
                fromGenericBeToGenericFe(commercialSegmentsData);
            setCommercialSegmentList(commercialSegmentList);

            setCurrencies(currenciesData);
            setChargingWays(chargingWaysData);
            setAncillaryTypes(typesData);

            if ((locationState?.ancillaryId || id || ancillaryId) && !ancillaryForm?.id) {

                const ancillary: AncillaryEntityResponse = await getAncillary((id || locationState?.ancillaryId || ancillaryId) as number);

                if (ancillary) {
                    const ancillaryInUse: boolean = await getAncillaryInUse({
                        ancillaryId: ancillary.id,
                    });
                    const services = await getServiceItem(ancillary.legalEntity, ancillary.dealer);
                    setServiceItem(services);

                    setAncillaryInUse(ancillaryInUse);
                    const ancillaryForm: FormAncillaryModel =
                        buildAncillaryForm(ancillary, t, services);
                    setAncillary(ancillary);
                    form.reset(ancillaryForm);
                    setAncillaryForm(ancillaryForm);
                    const originalAncillaryForm: FormAncillaryModel = JSON.parse(
                        JSON.stringify(ancillaryForm)
                    );

                    setOriginalAncillaryForm(originalAncillaryForm);
                }
            }
        } catch (e) {
        }
    };

    // Use Effect
    useEffect(() => {
        getStaticContents();
        // eslint-disable-next-line
    }, []);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        // click su matrice dei prezzi ma ancillary non ancora creata
        if (newValue === 1 && !ancillaryForm?.id && !readOnly) {
            dispatchGlobalData({
                type: setSnackbar,
                payload: {
                    snackbar: {
                        message: t(
                            "pricing:ancillary.dialogContents.createAncillaryMatrix"
                        ),
                        type: snackbarTypes.warning,
                        show: true,
                        autoClose: true,
                    },
                },
            });
        } else if (newValue === 0 && !readOnly) {
            setDialog({
                open: true,
                message: t("pricing:dialogs.messages.looseChanging"),
                onClickConfirm: () => {
                    setDialog(null);
                    setValue(newValue);
                },
            });
        }
        // click su ancillary
        else {
            setValue(newValue);
        }
    };

    return (
        <Grid sx={{padding: 0}}>
            <Box sx={{borderBottom: 1, borderColor: "divider"}}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                >
                    <Tab label={t("pricing:ancillary.title")}/>
                    <Tab label={t("pricing:ancillaryMatrix.title")}/>
                </Tabs>
            </Box>
            <FormProvider {...form}>
                <TabPanel value={value} index={0}>
                    <AncillaryBaseDefinition
                        readOnly={readOnly}
                        handleSubmit={form.handleSubmit(handleSubmit)}
                        ancillaryInUse={ancillaryInUse}
                    />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    {ancillary?.isOneWay ? (
                        <OWRouteMatrix
                            owAncillaryId={
                                ancillaryId ||
                                locationState?.ancillaryId ||
                                ancillaryForm?.id ||
                                null
                            }
                            readOnly={readOnly}
                            ancillaryInUse={ancillaryInUse}
                            setValue={setValue}
                        />
                    ) : (
                        <AncillaryMatrix
                            ancillaryId={
                                ancillaryId ||
                                locationState?.ancillaryId ||
                                ancillaryForm?.id ||
                                null
                            }
                            readOnly={readOnly}
                            ancillaryInUse={ancillaryInUse}
                            setValue={setValue}
                        />
                    )}
                </TabPanel>
            </FormProvider>
            {dialog?.open && (
                <DialogComponent
                    type={"info"}
                    onClickConfirm={dialog.onClickConfirm}
                    setOpen={() => setDialog(null)}
                    open={dialog.open}
                    message={dialog.message}
                />
            )}
            <Loading/>
        </Grid>
    );
};

export default AncillaryContent;
